"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _classnames = _interopRequireDefault(require("classnames"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _includes2 = _interopRequireDefault(require("lodash/includes"));
var _map2 = _interopRequireDefault(require("lodash/map"));
var _mapKeys2 = _interopRequireDefault(require("lodash/mapKeys"));
var _omit2 = _interopRequireDefault(require("lodash/omit"));
var _pull2 = _interopRequireDefault(require("lodash/pull"));
var _sortBy2 = _interopRequireDefault(require("lodash/sortBy"));
var _uniqBy2 = _interopRequireDefault(require("lodash/uniqBy"));
var _DropdownList = _interopRequireDefault(require("react-widgets/lib/DropdownList"));
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _arrowDown = _interopRequireDefault(require("cccisd-icons/arrow-down5"));
var _checkmark = _interopRequireDefault(require("cccisd-icons/checkmark4"));
var _bin = _interopRequireDefault(require("cccisd-icons/bin"));
var _info = _interopRequireDefault(require("cccisd-icons/info2"));
var _plusCircle = _interopRequireDefault(require("cccisd-icons/plus-circle"));
var _undo = _interopRequireDefault(require("cccisd-icons/undo"));
var _cancelSquare = _interopRequireDefault(require("cccisd-icons/cancel-square"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _cccisdValidator = _interopRequireDefault(require("cccisd-validator"));
var _admin = require("../../selectors/admin.js");
var _MessageViewer = _interopRequireDefault(require("./MessageViewer"));
var _Scheduler = _interopRequireDefault(require("./Scheduler.js"));
var _modalstyle_saveMessageScheduleMessage = _interopRequireDefault(require("./modalstyle_saveMessageScheduleMessage.css"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var NOTE = 'NOTIFICATION';
var Boilerplate = window.cccisd && window.cccisd.boilerplate;
var Fortress = window.cccisd && window.cccisd.fortress;
var moduleCompleteConditions = ['on_respondent_complete_module', 'on_respondent_complete_module_notify'];
var surveyCompleteConditions = ['on_respondent_complete_survey', 'on_respondent_complete_survey_notify'];
var SaveMessageModalContents = /*#__PURE__*/function (_React$Component) {
  _inherits(SaveMessageModalContents, _React$Component);
  var _super = _createSuper(SaveMessageModalContents);
  function SaveMessageModalContents() {
    var _this;
    _classCallCheck(this, SaveMessageModalContents);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      hasInitialized: false,
      hasSubmitted: false,
      hasScheduleError: false,
      isRecipientListCollapsed: true,
      isAddingRecipient: false,
      isSubmitting: false,
      emailRecipients: [],
      smsRecipients: [],
      currentlyEditingRecList: [],
      recEdits: {},
      children: [],
      label: '',
      // new message values
      condition: '',
      method: 'email',
      scheduleOffset: '',
      scheduleOffsetNumber: '',
      scheduleOffsetUnits: 'day',
      recipientsType: '',
      moduleId: '',
      surveyHandle: '',
      // text values
      subject: '',
      body: '',
      // body-top
      outroLines: '',
      // body-bottom
      actionText: 'Take Survey',
      actionUrl: '%URL%',
      duplicateLabel: false
    });
    _defineProperty(_assertThisInitialized(_this), "initializeState", function () {
      var messageObj = _this.props.messageObj;
      if (messageObj === null) {
        _this.setState({
          hasInitialized: true
        });
        return;
      }
      var children = [];
      if (messageObj.children.length) {
        var _iterator = _createForOfIteratorHelper(messageObj.children),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var child = _step.value;
            if (!child.condition.startsWith('scheduled_')) {
              children.push({
                id: child.messageId,
                scheduleTime: child.scheduleTime
              });
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      var messageInfo = messageObj.messageInfo;
      var scheduleOffset = messageObj.scheduleOffset || '';
      var scheduleOffsetParts = scheduleOffset.split(' ').filter(function (item) {
        return item;
      });
      var scheduleOffsetNumber = scheduleOffsetParts.length >= 2 ? scheduleOffsetParts[0] : '';
      var scheduleOffsetUnits = scheduleOffsetParts.length >= 2 ? scheduleOffsetParts[1] : 'day';
      _this.setState(_defineProperty({
        hasInitialized: true,
        label: messageObj.settings.label,
        children: children,
        // new message values
        condition: messageObj.condition,
        method: messageObj.messageMethod,
        scheduleOffset: scheduleOffset,
        scheduleOffsetNumber: scheduleOffsetNumber,
        scheduleOffsetUnits: scheduleOffsetUnits,
        recipientsType: messageObj.settings.recipientsType,
        moduleId: messageObj.settings.moduleId || '',
        surveyHandle: messageObj.settings.surveyHandle || '',
        // text values
        subject: messageInfo.subject || '',
        body: messageInfo.body || '',
        // body-top
        actionText: messageInfo.actionText || '',
        actionUrl: messageInfo.actionUrl || '',
        outroLines: messageInfo.outroLines || ''
      }, messageObj.messageMethod === 'email' ? 'emailRecipients' : 'smsRecipients', messageObj.recipients !== null ? _toConsumableArray(messageObj.recipients) : []));
    });
    _defineProperty(_assertThisInitialized(_this), "getErrors", function () {
      var errors = {};
      var _this$state = _this.state,
        actionText = _this$state.actionText,
        actionUrl = _this$state.actionUrl,
        body = _this$state.body,
        children = _this$state.children,
        condition = _this$state.condition,
        duplicateLabel = _this$state.duplicateLabel,
        emailRecipients = _this$state.emailRecipients,
        hasScheduleError = _this$state.hasScheduleError,
        label = _this$state.label,
        method = _this$state.method,
        moduleId = _this$state.moduleId,
        outroLines = _this$state.outroLines,
        smsRecipients = _this$state.smsRecipients,
        subject = _this$state.subject,
        surveyHandle = _this$state.surveyHandle;
      if (hasScheduleError) {
        errors.scheduleError = 'You must resolve the noted schedule errors';
      }
      if (duplicateLabel) {
        errors.label = 'Please use a different label';
      }
      if (!label) {
        errors.label = 'You must provide a Label';
      }
      if (!condition) {
        errors.condition = 'You must select a Condition';
      } else if (['target_met', 'on_respondent_complete_notify', 'on_respondent_complete_module_notify', 'on_respondent_complete_survey_notify'].includes(condition) || ['target_not_met'].includes(condition) && children.length) {
        if (method === 'email' && !emailRecipients.length) {
          errors.recipients = 'You must specify recipients';
        }
        if (method === 'sms' && !smsRecipients.length) {
          errors.recipients = 'You must specify recipients';
        }
      }
      if (moduleCompleteConditions.includes(condition) && !moduleId) {
        errors.moduleId = 'You must select a Module';
      }
      if (surveyCompleteConditions.includes(condition) && !surveyHandle) {
        errors.surveyHandle = 'You must select a Survey';
      }
      if (method === 'email') {
        if (actionText && !actionUrl) {
          errors.actionUrl = 'You must supply a Button URL if Button Text is provided';
        }
        if (!actionText && actionUrl) {
          errors.actionText = 'You must supply Button Text if a Button URL is provided';
        }
        if (!subject) {
          errors.subject = 'You must supply a Subject';
        }
        if (!body && !outroLines) {
          errors.body = 'You must supply either Body (upper) or Body (lower)';
          errors.outroLines = 'You must supply either Body (upper) or Body (lower)';
        }
      } else if (!body) {
        errors.body = 'You must supply a Body';
      }
      return errors;
    });
    _defineProperty(_assertThisInitialized(_this), "toggleCollapse", function () {
      _this.setState(function (prevState) {
        return {
          isRecipientListCollapsed: !prevState.isRecipientListCollapsed,
          isAddingRecipient: false
        };
      });
    });
    _defineProperty(_assertThisInitialized(_this), "getMessageInfoObject", function () {
      return _this.state.method.toUpperCase() === 'EMAIL' ? {
        subject: _this.state.subject,
        body: _this.state.body,
        outroLines: _this.state.outroLines,
        actionText: _this.state.actionText,
        actionUrl: _this.state.actionUrl
      } : {
        body: _this.state.body
      };
    });
    _defineProperty(_assertThisInitialized(_this), "onChildrenChange", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(children) {
        var processedChildren, _iterator2, _step2, child, copyChild;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                processedChildren = [];
                _iterator2 = _createForOfIteratorHelper(children);
                try {
                  for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                    child = _step2.value;
                    copyChild = Object.assign({}, child);
                    if (!copyChild.isNew) {
                      copyChild.id = copyChild.messageId;
                    }
                    delete copyChild.messageId;
                    processedChildren.push(copyChild);
                  }
                } catch (err) {
                  _iterator2.e(err);
                } finally {
                  _iterator2.f();
                }
                _context.next = 5;
                return _this.setState({
                  children: processedChildren
                });
              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "onSaveSubmit", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var _this$props, deploymentId, closeModal, _this$state2, children, condition, emailRecipients, label, method, moduleId, recipientsType, scheduleOffset, smsRecipients, surveyHandle, messageData, recipientConditions, response, errorData;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this.setState({
                hasSubmitted: true
              });
            case 2:
              if (!(Object.keys(_this.getErrors()).length > 0)) {
                _context2.next = 6;
                break;
              }
              _context2.next = 5;
              return _this.setState({
                isSubmitting: false
              });
            case 5:
              return _context2.abrupt("return");
            case 6:
              _this$props = _this.props, deploymentId = _this$props.deploymentId, closeModal = _this$props.closeModal;
              _this$state2 = _this.state, children = _this$state2.children, condition = _this$state2.condition, emailRecipients = _this$state2.emailRecipients, label = _this$state2.label, method = _this$state2.method, moduleId = _this$state2.moduleId, recipientsType = _this$state2.recipientsType, scheduleOffset = _this$state2.scheduleOffset, smsRecipients = _this$state2.smsRecipients, surveyHandle = _this$state2.surveyHandle;
              messageData = {
                condition: condition,
                messageMethod: method,
                messageInfo: _this.getMessageInfoObject(),
                scheduleOffset: scheduleOffset,
                settings: {
                  label: label,
                  recipientsType: recipientsType
                },
                children: children
              };
              if (moduleCompleteConditions.includes(condition)) {
                messageData.settings.moduleId = moduleId;
              }
              if (surveyCompleteConditions.includes(condition)) {
                messageData.settings.surveyHandle = surveyHandle;
              }
              recipientConditions = ['on_respondent_complete_notify', 'on_respondent_complete_module_notify', 'on_respondent_complete_survey_notify', 'target_met', 'target_not_met'];
              if (recipientConditions.includes(condition)) {
                messageData.recipients = method === 'email' ? emailRecipients : smsRecipients;
              }
              _context2.next = 15;
              return _cccisdAxios["default"].post(Boilerplate.route('api.assignmentDeploymentMessage.store', {
                deploymentId: deploymentId
              }), messageData);
            case 15:
              response = _context2.sent;
              if (!(response.data.status === 'success')) {
                _context2.next = 22;
                break;
              }
              _context2.next = 19;
              return _this.props.requeryCallback();
            case 19:
              closeModal();
              _this.setState({
                isSubmitting: false
              });
              return _context2.abrupt("return", (0, _cccisdNotification["default"])({
                type: 'success',
                message: "Successfully saved ".concat(recipientsType, " message '").concat(label, "'")
              }));
            case 22:
              errorData = response.data && response.data.errors || {};
              if (Object.keys(errorData).length) {
                console.error(errorData);
              }
              _this.setState({
                isSubmitting: false
              });
              return _context2.abrupt("return", (0, _cccisdNotification["default"])({
                type: 'danger',
                message: "Failed to save message ".concat(label)
              }));
            case 26:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));
    _defineProperty(_assertThisInitialized(_this), "onEditSubmit", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var _this$props2, messageObj, deploymentId, closeModal, _this$state3, children, condition, emailRecipients, label, method, moduleId, recipientsType, scheduleOffset, smsRecipients, surveyHandle, updateParams, response, errorData;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this.setState({
                hasSubmitted: true
              });
            case 2:
              if (!(Object.keys(_this.getErrors()).length > 0)) {
                _context3.next = 6;
                break;
              }
              _context3.next = 5;
              return _this.setState({
                isSubmitting: false
              });
            case 5:
              return _context3.abrupt("return");
            case 6:
              _this$props2 = _this.props, messageObj = _this$props2.messageObj, deploymentId = _this$props2.deploymentId, closeModal = _this$props2.closeModal;
              _this$state3 = _this.state, children = _this$state3.children, condition = _this$state3.condition, emailRecipients = _this$state3.emailRecipients, label = _this$state3.label, method = _this$state3.method, moduleId = _this$state3.moduleId, recipientsType = _this$state3.recipientsType, scheduleOffset = _this$state3.scheduleOffset, smsRecipients = _this$state3.smsRecipients, surveyHandle = _this$state3.surveyHandle;
              updateParams = {
                condition: condition,
                messageMethod: method,
                recipients: method === 'email' ? emailRecipients : smsRecipients,
                messageInfo: _this.getMessageInfoObject(),
                scheduleOffset: scheduleOffset,
                settings: _objectSpread(_objectSpread({}, messageObj.settings), {}, {
                  label: label,
                  recipientsType: recipientsType
                }),
                children: children
              };
              if (moduleCompleteConditions.includes(condition)) {
                updateParams.settings.moduleId = moduleId;
              }
              if (surveyCompleteConditions.includes(condition)) {
                updateParams.settings.surveyHandle = surveyHandle;
              }
              _context3.next = 13;
              return _cccisdAxios["default"].put(Boilerplate.route('api.assignmentDeploymentMessage.update', {
                deploymentId: deploymentId,
                deploymentMessageId: messageObj.messageId
              }), updateParams);
            case 13:
              response = _context3.sent;
              if (!(response.data.status === 'success')) {
                _context3.next = 20;
                break;
              }
              _context3.next = 17;
              return _this.props.requeryCallback();
            case 17:
              closeModal();
              _this.setState({
                isSubmitting: false
              });
              return _context3.abrupt("return", (0, _cccisdNotification["default"])({
                type: 'success',
                message: "Successfully updated ".concat(recipientsType, " message '").concat(label, "'")
              }));
            case 20:
              errorData = response.data && response.data.errors || {};
              if (Object.keys(errorData).length) {
                console.error(errorData);
              }
              _this.setState({
                isSubmitting: false
              });
              return _context3.abrupt("return", (0, _cccisdNotification["default"])({
                type: 'danger',
                message: "Failed to update message ".concat(label)
              }));
            case 24:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    })));
    _defineProperty(_assertThisInitialized(_this), "onScheduleError", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _this.setState({
                hasScheduleError: true
              });
            case 2:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    })));
    _defineProperty(_assertThisInitialized(_this), "onScheduleErrorResolved", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return _this.setState({
                hasScheduleError: false
              });
            case 2:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    })));
    _defineProperty(_assertThisInitialized(_this), "onScheduleOffsetNumberChange", /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(value) {
        var scheduleOffsetUnits, parsedValue, newScheduleOffsetNumber, newScheduleOffset;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                scheduleOffsetUnits = _this.state.scheduleOffsetUnits;
                parsedValue = Number.parseInt(value, 10);
                newScheduleOffsetNumber = parsedValue > 0 ? parsedValue : '';
                newScheduleOffset = newScheduleOffsetNumber ? "".concat(newScheduleOffsetNumber, " ").concat(scheduleOffsetUnits) : '';
                _context6.next = 6;
                return _this.setState({
                  scheduleOffset: newScheduleOffset,
                  scheduleOffsetNumber: newScheduleOffsetNumber
                });
              case 6:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));
      return function (_x2) {
        return _ref6.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "onScheduleOffsetUnitsChange", /*#__PURE__*/function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(value) {
        var scheduleOffsetNumber, newScheduleOffset;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                scheduleOffsetNumber = _this.state.scheduleOffsetNumber;
                newScheduleOffset = scheduleOffsetNumber ? "".concat(scheduleOffsetNumber, " ").concat(value) : '';
                _context7.next = 4;
                return _this.setState({
                  scheduleOffset: newScheduleOffset,
                  scheduleOffsetUnits: value
                });
              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));
      return function (_x3) {
        return _ref7.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "_renderRecipientsList", function () {
      var _this$state4 = _this.state,
        currentlyEditingRecList = _this$state4.currentlyEditingRecList,
        emailRecipients = _this$state4.emailRecipients,
        isAddingRecipient = _this$state4.isAddingRecipient,
        isRecipientListCollapsed = _this$state4.isRecipientListCollapsed,
        isSubmitting = _this$state4.isSubmitting,
        method = _this$state4.method,
        recEdits = _this$state4.recEdits,
        smsRecipients = _this$state4.smsRecipients;
      if (isRecipientListCollapsed) {
        return;
      }
      var isEmail = method === 'email';
      var currList = isEmail ? emailRecipients : smsRecipients;

      // EDITING BOX
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('panel-body', _modalstyle_saveMessageScheduleMessage["default"].panelList)
      }, (0, _map2["default"])(currList, function (rec) {
        // if editing receiver
        if ((0, _includes2["default"])(currentlyEditingRecList, rec)) {
          return /*#__PURE__*/_react["default"].createElement("label", {
            key: rec,
            className: "form-group"
          }, /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
            title: rec
          }, /*#__PURE__*/_react["default"].createElement("a", {
            className: (0, _classnames["default"])('btn btn-default', _modalstyle_saveMessageScheduleMessage["default"].cancel, isSubmitting && 'disabled'),
            onClick: function onClick() {
              if (!isSubmitting) {
                _this.undoEditingRecipient(rec);
              }
            }
          }, /*#__PURE__*/_react["default"].createElement(_undo["default"], null))), /*#__PURE__*/_react["default"].createElement("input", {
            className: "form-control",
            type: isEmail ? 'email' : 'tel',
            placeholder: isEmail ? 'Email address' : 'Phone number',
            defaultValue: recEdits[rec],
            onChange: function onChange(e) {
              _this.setState({
                recEdits: _objectSpread(_objectSpread({}, recEdits), {}, _defineProperty({}, rec, e.target.value))
              });
            }
          }), /*#__PURE__*/_react["default"].createElement("a", {
            className: (0, _classnames["default"])('btn btn-primary', _modalstyle_saveMessageScheduleMessage["default"].add, isSubmitting && 'disabled'),
            onClick: function onClick() {
              if (!isSubmitting) {
                _this.updateEditingRecipient(rec, recEdits[rec]);
              }
            }
          }, /*#__PURE__*/_react["default"].createElement(_checkmark["default"], null)));
        }

        // if not editing receiver
        return /*#__PURE__*/_react["default"].createElement("label", {
          key: rec
        }, /*#__PURE__*/_react["default"].createElement("p", {
          className: _modalstyle_saveMessageScheduleMessage["default"].editReceiver,
          onClick: function onClick() {
            if (!isSubmitting) {
              _this.editRecipient(rec);
            }
          }
        }, rec), /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
          title: "Delete",
          type: "error"
        }, /*#__PURE__*/_react["default"].createElement("a", {
          className: (0, _classnames["default"])('btn btn-danger', _modalstyle_saveMessageScheduleMessage["default"]["delete"], isSubmitting && 'disabled'),
          onClick: function onClick() {
            if (!isSubmitting) {
              _this.removeRecipient(rec);
            }
          }
        }, /*#__PURE__*/_react["default"].createElement(_bin["default"], null))));
      }), isAddingRecipient ? /*#__PURE__*/_react["default"].createElement("label", {
        className: "form-group"
      }, /*#__PURE__*/_react["default"].createElement("a", {
        className: (0, _classnames["default"])('btn btn-default', _modalstyle_saveMessageScheduleMessage["default"].cancel, isSubmitting && 'disabled'),
        onClick: function onClick() {
          if (!isSubmitting) {
            _this.setState({
              isAddingRecipient: false
            });
          }
        }
      }, /*#__PURE__*/_react["default"].createElement(_cancelSquare["default"], null)), /*#__PURE__*/_react["default"].createElement("input", {
        className: "form-control",
        type: isEmail ? 'email' : 'tel',
        placeholder: isEmail ? 'Email address' : 'Phone number',
        ref: function ref(input) {
          _this.recipientToBeAdded = input;
        }
      }), /*#__PURE__*/_react["default"].createElement("a", {
        className: (0, _classnames["default"])('btn btn-primary', _modalstyle_saveMessageScheduleMessage["default"].add),
        onClick: _this.addRecipient
      }, /*#__PURE__*/_react["default"].createElement(_plusCircle["default"], null))) : /*#__PURE__*/_react["default"].createElement("label", {
        className: "form-group"
      }, /*#__PURE__*/_react["default"].createElement("a", {
        className: (0, _classnames["default"])('btn btn-default', _modalstyle_saveMessageScheduleMessage["default"].addRecipientButton, isSubmitting && 'disabled'),
        onClick: function onClick() {
          if (!isSubmitting) {
            _this.setState({
              isAddingRecipient: true
            });
          }
        }
      }, /*#__PURE__*/_react["default"].createElement(_plusCircle["default"], null), " Add ", isEmail ? 'Email Address' : 'Phone Number')));
    });
    _defineProperty(_assertThisInitialized(_this), "addRecipient", function () {
      var _this$setState2;
      var isEmail = _this.state.method === 'email';
      var recipient = _this.recipientToBeAdded.value.trim();
      if (recipient === '') {
        _this.setState({
          isAddingRecipient: false
        });
        return;
      }
      var validationResult = (0, _cccisdValidator["default"])(recipient, {
        types: isEmail ? ['email'] : ['phoneNumber']
      });
      if (validationResult.status === 'fail') {
        return (0, _cccisdNotification["default"])({
          type: 'danger',
          message: validationResult.errors[Object.keys(validationResult.errors)[0]]
        });
      }
      var key = isEmail ? 'emailRecipients' : 'smsRecipients';
      var recipientList = _this.state[key];
      if (recipientList.includes(recipient)) {
        return (0, _cccisdNotification["default"])({
          type: 'danger',
          message: "".concat(recipient, " already exists")
        });
      }
      recipientList.push(recipient);
      _this.setState((_this$setState2 = {}, _defineProperty(_this$setState2, key, recipientList), _defineProperty(_this$setState2, "isAddingRecipient", false), _defineProperty(_this$setState2, "newRecipient", ''), _this$setState2));
    });
    _defineProperty(_assertThisInitialized(_this), "removeRecipient", function (recipient) {
      var isEmail = _this.state.method === 'email';
      var key = isEmail ? 'emailRecipients' : 'smsRecipients';
      var recipientList = _this.state[key];
      (0, _pull2["default"])(recipientList, recipient);
      _this.setState(_defineProperty({}, key, recipientList));
    });
    _defineProperty(_assertThisInitialized(_this), "editRecipient", function (recipient) {
      if (!(0, _includes2["default"])(_this.state.currentlyEditingRecList, recipient)) {
        var newList = _this.state.currentlyEditingRecList;
        newList.push(recipient);
        _this.setState({
          currentlyEditingRecList: newList,
          recEdits: _objectSpread(_objectSpread({}, _this.state.recEdits), {}, _defineProperty({}, recipient, recipient))
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "updateEditingRecipient", function (oldVal, newVal) {
      var isEmail = _this.state.method === 'email';
      if (newVal === '') {
        return (0, _cccisdNotification["default"])({
          type: 'danger',
          message: 'Updated value was empty'
        });
      }
      var validationResult = (0, _cccisdValidator["default"])(newVal, {
        types: isEmail ? ['email'] : ['phoneNumber']
      });
      if (validationResult.status === 'fail') {
        return (0, _cccisdNotification["default"])({
          type: 'danger',
          message: validationResult.errors[Object.keys(validationResult.errors)[0]]
        });
      }
      var key = isEmail ? 'emailRecipients' : 'smsRecipients';
      var recipList = _this.state[key];
      if (recipList.includes(newVal)) {
        return (0, _cccisdNotification["default"])({
          type: 'danger',
          message: "".concat(newVal, " already exists")
        });
      }

      // replace value
      var recIndex = recipList.indexOf(oldVal);
      if (recIndex !== -1) {
        recipList[recIndex] = newVal;
      } else {
        // SHOULD NEVER HAPPEN
        return (0, _cccisdNotification["default"])({
          type: 'danger',
          message: "".concat(oldVal, " not found")
        });
      }
      _this.setState(_defineProperty({}, key, recipList));

      // remove from editing lists
      _this.undoEditingRecipient(oldVal);
    });
    _defineProperty(_assertThisInitialized(_this), "updateAllEditingRecipients", function () {
      (0, _mapKeys2["default"])(_this.state.recEdits, function (val, key) {
        _this.updateEditingRecipient(key, val);
      });
    });
    _defineProperty(_assertThisInitialized(_this), "undoEditingRecipient", function (recipient) {
      var recList = (0, _omit2["default"])(_this.state.recEdits, [recipient]);
      var editList = _this.state.currentlyEditingRecList;
      (0, _pull2["default"])(editList, recipient);
      _this.setState({
        currentlyEditingRecList: editList,
        recEdits: recList
      });
    });
    _defineProperty(_assertThisInitialized(_this), "useScheduler", function (condition) {
      return !['target_met', 'on_respondent_complete', 'on_respondent_complete_notify', 'on_respondent_complete_module', 'on_respondent_complete_module_notify', 'on_respondent_complete_survey', 'on_respondent_complete_survey_notify', 'on_respondent_rostered', ''].includes(condition.toLowerCase());
    });
    _defineProperty(_assertThisInitialized(_this), "_getConditions", function () {
      var _this$props3 = _this.props,
        deploymentId = _this$props3.deploymentId,
        deployments = _this$props3.deployments,
        isEditing = _this$props3.isEditing;
      var _this$state5 = _this.state,
        condition = _this$state5.condition,
        recipientsType = _this$state5.recipientsType;
      var conditions = [{
        value: '',
        label: '-- Choose Condition --'
      }];
      var respondentTriggeredConditions = [{
        value: 'on_respondent_complete',
        label: 'Send on Respondent Complete'
      }, {
        value: 'on_respondent_complete_survey',
        label: 'Send on Respondent Completion of a Survey'
      }];
      if (_this._hasModules()) {
        respondentTriggeredConditions.push({
          value: 'on_respondent_complete_module',
          label: 'Send on Respondent Completion of a Module'
        });
      }
      var deployment = deployments.find(function (d) {
        return d.deploymentId === deploymentId;
      }) || {};
      if (deployment.type === 'known' || (0, _get2["default"])(deployment, 'settings.closedRoster')) {
        respondentTriggeredConditions.push({
          value: 'on_respondent_rostered',
          label: 'Send on Respondent Added to Roster'
        });
      }
      var respondentScheduledConditions = [{
        value: 'all_respondents',
        label: 'All Respondents'
      }, {
        value: 'not_started',
        label: 'All Not Started'
      },
      // TODO: only include if not anonymous
      {
        value: 'incomplete',
        label: 'All Partially Completed'
      }, {
        value: 'incomplete_or_not_started',
        label: 'All Partially Completed or Not Started'
      }, {
        value: 'complete',
        label: 'All Completed'
      }];
      var receiverTriggeredConditions = [{
        value: 'on_respondent_complete_notify',
        label: 'Send on Respondent Complete'
      }, {
        value: 'on_respondent_complete_survey_notify',
        label: 'Send on Respondent Completion of a Survey'
      }];
      if (_this._hasModules()) {
        receiverTriggeredConditions.push({
          value: 'on_respondent_complete_module_notify',
          label: 'Send on Respondent Completion of a Module'
        });
      }
      receiverTriggeredConditions.push({
        value: 'target_met',
        label: 'When Target Is Met'
      });
      var receiverScheduledConditions = [{
        value: 'target_not_met',
        label: 'If Target Not Met'
      }];
      if (recipientsType.toUpperCase() === NOTE) {
        if (isEditing) {
          if (receiverTriggeredConditions.find(function (c) {
            return c.value === condition;
          })) {
            conditions = conditions.concat(receiverTriggeredConditions);
          } else {
            conditions = conditions.concat(receiverScheduledConditions);
          }
        } else {
          conditions = conditions.concat(receiverTriggeredConditions, receiverScheduledConditions);
        }
      } else if (isEditing) {
        if (respondentTriggeredConditions.find(function (c) {
          return c.value === condition;
        })) {
          conditions = conditions.concat(respondentTriggeredConditions);
        } else {
          conditions = conditions.concat(respondentScheduledConditions);
        }
      } else {
        conditions = conditions.concat(respondentTriggeredConditions, respondentScheduledConditions);
      }
      return conditions;
    });
    _defineProperty(_assertThisInitialized(_this), "_getModuleOptions", function () {
      var _this$props4 = _this.props,
        assignments = _this$props4.assignments,
        deploymentId = _this$props4.deploymentId;
      var condition = _this.state.condition;
      var modules = [];
      if (moduleCompleteConditions.includes(condition)) {
        var assignment = assignments.find(function (a) {
          return a.deploymentList.find(function (d) {
            return Number(d.deploymentId) === Number(deploymentId);
          });
        }) || {};
        var navSettings = (0, _get2["default"])(assignment, 'settings.navigationSettings.course.navigationSettings') || (0, _get2["default"])(assignment, 'settings.navigationSettings', {});
        modules = _toConsumableArray(navSettings.modules);
      }
      modules.unshift({
        id: '',
        title: '--- Select a Module ---'
      });
      return modules;
    });
    _defineProperty(_assertThisInitialized(_this), "_getSurveyOptions", function () {
      var _this$props5 = _this.props,
        assignments = _this$props5.assignments,
        deploymentId = _this$props5.deploymentId;
      var condition = _this.state.condition;
      var surveys = [];
      if (surveyCompleteConditions.includes(condition)) {
        var assignment = assignments.find(function (a) {
          return a.deploymentList.find(function (d) {
            return Number(d.deploymentId) === Number(deploymentId);
          });
        }) || {};
        assignment.surveylistList.forEach(function (sl) {
          surveys = surveys.concat(sl.surveyList);
        });
        surveys = (0, _uniqBy2["default"])(surveys, 'surveyHandle');
        surveys = (0, _sortBy2["default"])(surveys, 'position');
      }
      surveys.unshift({
        surveyHandle: '',
        label: '--- Select a Survey ---'
      });
      return surveys;
    });
    _defineProperty(_assertThisInitialized(_this), "_hasModules", function () {
      var _this$props6 = _this.props,
        assignments = _this$props6.assignments,
        deploymentId = _this$props6.deploymentId;
      var assignment = assignments.find(function (a) {
        return a.deploymentList.find(function (d) {
          return Number(d.deploymentId) === Number(deploymentId);
        });
      }) || {};
      var navStyle = (0, _get2["default"])(assignment, 'settings.navigationSettings.course.navigation') || (0, _get2["default"])(assignment, 'settings.navigation', '');
      return navStyle.startsWith('module');
    });
    _defineProperty(_assertThisInitialized(_this), "renderHtmlTagTooltip", function () {
      return /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: /*#__PURE__*/_react["default"].createElement("span", null, "Can include basic HTML tags, such as <b>, <i>, or <u>")
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: (0, _classnames["default"])('text-primary', _style["default"].infoBubble)
      }, /*#__PURE__*/_react["default"].createElement(_info["default"], null)));
    });
    _defineProperty(_assertThisInitialized(_this), "checkLabel", /*#__PURE__*/function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(e) {
        var match;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                match = _this.props.messageList.find(function (item) {
                  return item.settings.label === e.target.value;
                });
                if (match) {
                  _this.setState({
                    duplicateLabel: true,
                    label: e.target.value
                  });
                } else {
                  _this.setState({
                    duplicateLabel: false,
                    label: e.target.value
                  });
                }
              case 2:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));
      return function (_x4) {
        return _ref8.apply(this, arguments);
      };
    }());
    return _this;
  }
  _createClass(SaveMessageModalContents, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.initializeState();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var isEditing = this.props.isEditing;
      var _this$state6 = this.state,
        actionText = _this$state6.actionText,
        actionUrl = _this$state6.actionUrl,
        body = _this$state6.body,
        condition = _this$state6.condition,
        currentlyEditingRecList = _this$state6.currentlyEditingRecList,
        emailRecipients = _this$state6.emailRecipients,
        hasSubmitted = _this$state6.hasSubmitted,
        hasInitialized = _this$state6.hasInitialized,
        isAddingRecipient = _this$state6.isAddingRecipient,
        isRecipientListCollapsed = _this$state6.isRecipientListCollapsed,
        isSubmitting = _this$state6.isSubmitting,
        label = _this$state6.label,
        method = _this$state6.method,
        moduleId = _this$state6.moduleId,
        newRecipient = _this$state6.newRecipient,
        outroLines = _this$state6.outroLines,
        recipientsType = _this$state6.recipientsType,
        scheduleOffsetNumber = _this$state6.scheduleOffsetNumber,
        scheduleOffsetUnits = _this$state6.scheduleOffsetUnits,
        smsRecipients = _this$state6.smsRecipients,
        subject = _this$state6.subject,
        surveyHandle = _this$state6.surveyHandle;
      if (!hasInitialized) {
        return null;
      }

      // collapsed Recipient List style
      var collapseStyle = isRecipientListCollapsed ? _modalstyle_saveMessageScheduleMessage["default"].collapsed : _modalstyle_saveMessageScheduleMessage["default"].expanded;

      // change submit button text if a list is being edited
      var submitVar = currentlyEditingRecList.length > 0 || isAddingRecipient ? 'Save List(s) and Submit' : 'Submit';

      // preview message object
      var previewMessageObject = {
        condition: condition,
        messageMethod: method,
        category: 'preview',
        recipients: [].concat(_toConsumableArray(method === 'email' ? emailRecipients : smsRecipients), [isAddingRecipient && newRecipient]),
        settings: {
          label: label,
          recipientsType: recipientsType,
          surveyHandle: surveyHandle
        },
        messageInfo: {
          subject: subject,
          body: body,
          outroLines: outroLines,
          actionText: actionText,
          actionUrl: actionUrl
        }
      };
      var errors = hasSubmitted ? this.getErrors() : {};
      var hasErrors = Object.keys(errors).length > 0;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])(_style["default"].commonModal, _modalstyle_saveMessageScheduleMessage["default"].saveMessageModal)
      }, /*#__PURE__*/_react["default"].createElement("form", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('form-group', _modalstyle_saveMessageScheduleMessage["default"].textField, {
          'has-error': errors.label
        })
      }, /*#__PURE__*/_react["default"].createElement("label", {
        className: "control-label"
      }, "Label\xA0", /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: "Create a label for this message to help you identify it"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: (0, _classnames["default"])('text-primary', _style["default"].infoBubble)
      }, /*#__PURE__*/_react["default"].createElement(_info["default"], null)))), /*#__PURE__*/_react["default"].createElement("div", {
        className: _modalstyle_saveMessageScheduleMessage["default"].fullwidth
      }, /*#__PURE__*/_react["default"].createElement("input", {
        type: "text",
        className: "form-control",
        placeholder: "Enter a label...",
        value: label,
        onChange: function onChange(e) {
          _this2.checkLabel(e);
        }
      }), this.state.duplicateLabel && this.state.label.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].labelUnavailable
      }, "Label already in use"), !this.state.duplicateLabel && this.state.label.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].labelAvailable
      }, "Label available"), errors.label && /*#__PURE__*/_react["default"].createElement("p", {
        className: (0, _classnames["default"])('help-block', _modalstyle_saveMessageScheduleMessage["default"].inputError)
      }, errors.label))), /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('form-group', _modalstyle_saveMessageScheduleMessage["default"].field)
      }, /*#__PURE__*/_react["default"].createElement("label", null, "Recipients"), /*#__PURE__*/_react["default"].createElement("select", {
        className: "form-control",
        onChange: function onChange(e) {
          _this2.setState({
            recipientsType: e.target.value,
            condition: ''
          });
        },
        value: recipientsType.toLowerCase(),
        disabled: !this.useScheduler(condition) && isEditing
      }, /*#__PURE__*/_react["default"].createElement("option", {
        disabled: recipientsType !== '',
        value: "default"
      }, "-- Choose Type --"), /*#__PURE__*/_react["default"].createElement("option", {
        value: "respondent"
      }, "Respondent(s)"), /*#__PURE__*/_react["default"].createElement("option", {
        value: "notification"
      }, "Receiver List ..."))), recipientsType.toUpperCase() === NOTE && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('panel panel-primary', _modalstyle_saveMessageScheduleMessage["default"].field, _modalstyle_saveMessageScheduleMessage["default"].panel)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('panel-heading', _modalstyle_saveMessageScheduleMessage["default"].panelHeader)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _modalstyle_saveMessageScheduleMessage["default"].collapseArrow,
        onClick: this.toggleCollapse.bind(null)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: collapseStyle
      }, /*#__PURE__*/_react["default"].createElement(_arrowDown["default"], null))), /*#__PURE__*/_react["default"].createElement("h3", {
        onClick: this.toggleCollapse.bind(null),
        className: "panel-title"
      }, "Receiver List (", method === 'email' ? emailRecipients.length : smsRecipients.length, ")")), this._renderRecipientsList()), errors.recipients && /*#__PURE__*/_react["default"].createElement("p", {
        className: _modalstyle_saveMessageScheduleMessage["default"].inputError
      }, errors.recipients), /*#__PURE__*/_react["default"].createElement("hr", null)), recipientsType !== '' && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('form-group', _modalstyle_saveMessageScheduleMessage["default"].field, {
          'has-error': errors.condition
        })
      }, /*#__PURE__*/_react["default"].createElement("label", {
        className: "control-label"
      }, "Condition\xA0", /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: "Condition relates to Quest unless otherwise noted."
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: (0, _classnames["default"])('text-primary', _style["default"].infoBubble)
      }, /*#__PURE__*/_react["default"].createElement(_info["default"], null)))), /*#__PURE__*/_react["default"].createElement("select", {
        className: "form-control",
        onChange: function onChange(e) {
          _this2.setState({
            condition: e.target.value
          });
        },
        value: condition,
        disabled: !this.useScheduler(condition) && isEditing
      }, (0, _map2["default"])(this._getConditions(), function (opt, index) {
        return /*#__PURE__*/_react["default"].createElement("option", {
          key: index + opt.value,
          value: opt.value,
          disabled: index === 0 && condition !== ''
        }, opt.label);
      })), errors.condition && /*#__PURE__*/_react["default"].createElement("p", {
        className: (0, _classnames["default"])('help-block', _modalstyle_saveMessageScheduleMessage["default"].inputError, _modalstyle_saveMessageScheduleMessage["default"].indentError)
      }, errors.condition)), moduleCompleteConditions.includes(condition) && /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('form-group', _modalstyle_saveMessageScheduleMessage["default"].field, {
          'has-error': errors.moduleId
        })
      }, /*#__PURE__*/_react["default"].createElement("label", {
        className: "control-label"
      }, "Module"), /*#__PURE__*/_react["default"].createElement("select", {
        className: "form-control",
        onChange: function onChange(e) {
          _this2.setState({
            moduleId: e.target.value
          });
        },
        value: moduleId
      }, (0, _map2["default"])(this._getModuleOptions(), function (opt, index) {
        return /*#__PURE__*/_react["default"].createElement("option", {
          key: index,
          value: opt.id
        }, opt.id ? "".concat(opt.id, ": \"").concat(opt.title, "\"") : opt.title);
      })), errors.moduleId && /*#__PURE__*/_react["default"].createElement("p", {
        className: (0, _classnames["default"])('help-block', _modalstyle_saveMessageScheduleMessage["default"].inputError, _modalstyle_saveMessageScheduleMessage["default"].indentError)
      }, errors.moduleId)), surveyCompleteConditions.includes(condition) && /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('form-group', _modalstyle_saveMessageScheduleMessage["default"].field, {
          'has-error': errors.surveyHandle
        })
      }, /*#__PURE__*/_react["default"].createElement("label", {
        className: "control-label"
      }, "Survey"), /*#__PURE__*/_react["default"].createElement("select", {
        className: "form-control",
        onChange: function onChange(e) {
          _this2.setState({
            surveyHandle: e.target.value
          });
        },
        value: surveyHandle
      }, (0, _map2["default"])(this._getSurveyOptions(), function (opt, index) {
        return /*#__PURE__*/_react["default"].createElement("option", {
          key: index,
          value: opt.surveyHandle
        }, opt.label);
      })), errors.surveyHandle && /*#__PURE__*/_react["default"].createElement("p", {
        className: (0, _classnames["default"])('help-block', _modalstyle_saveMessageScheduleMessage["default"].inputError, _modalstyle_saveMessageScheduleMessage["default"].indentError)
      }, errors.surveyHandle)), this.useScheduler(condition) && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Scheduler["default"], {
        deploymentId: this.props.deploymentId,
        templateMessageObject: this.props.messageObj,
        onScheduleChange: this.onChildrenChange,
        onScheduleError: this.onScheduleError,
        onScheduleErrorResolved: this.onScheduleErrorResolved
      }), /*#__PURE__*/_react["default"].createElement("hr", null)), /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('form-group', _modalstyle_saveMessageScheduleMessage["default"].field)
      }, /*#__PURE__*/_react["default"].createElement("label", null, "Message Type"), /*#__PURE__*/_react["default"].createElement("select", {
        className: "form-control",
        onChange: function onChange(e) {
          _this2.setState({
            method: e.target.value,
            isAddingRecipient: false
          });
        },
        value: method.toLowerCase()
      }, /*#__PURE__*/_react["default"].createElement("option", {
        value: "email"
      }, "Email Message"), /*#__PURE__*/_react["default"].createElement("option", {
        value: "sms"
      }, "SMS/Text Message"))), ['on_respondent_complete', 'on_respondent_complete_notify', 'on_respondent_complete_module', 'on_respondent_complete_module_notify', 'on_respondent_complete_survey', 'on_respondent_complete_survey_notify', 'on_respondent_rostered', 'target_met'].includes(condition) && !!Fortress.user.acting.is_super_user && /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('form-group', _modalstyle_saveMessageScheduleMessage["default"].textField)
      }, /*#__PURE__*/_react["default"].createElement("label", {
        className: "control-label"
      }, "Schedule Offset\xA0", /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: "Optional delay from the time of the triggering event (whole numbers only)."
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: (0, _classnames["default"])('text-primary', _style["default"].infoBubble)
      }, /*#__PURE__*/_react["default"].createElement(_info["default"], null)))), /*#__PURE__*/_react["default"].createElement("div", {
        className: _modalstyle_saveMessageScheduleMessage["default"].fullwidth
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          display: 'flex'
        }
      }, /*#__PURE__*/_react["default"].createElement("input", {
        type: "number",
        className: "form-control",
        placeholder: "",
        value: scheduleOffsetNumber,
        onChange: function onChange(e) {
          _this2.onScheduleOffsetNumberChange(e.target.value);
        },
        style: {
          height: '3.9rem'
        }
      }), /*#__PURE__*/_react["default"].createElement(_DropdownList["default"], {
        data: [{
          value: 'month',
          label: 'month(s)'
        }, {
          value: 'week',
          label: 'week(s)'
        }, {
          value: 'day',
          label: 'day(s)'
        }, {
          value: 'hour',
          label: 'hour(s)'
        }, {
          value: 'minute',
          label: 'minute(s)'
        }],
        onChange: function onChange(e) {
          _this2.onScheduleOffsetUnitsChange(e.value);
        },
        textField: "label",
        value: scheduleOffsetUnits,
        valueField: "value"
      })))), method !== '' && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("hr", null), /*#__PURE__*/_react["default"].createElement("span", {
        className: _modalstyle_saveMessageScheduleMessage["default"].textArea
      }, method === 'email' && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('form-group', _modalstyle_saveMessageScheduleMessage["default"].textField, {
          'has-error': errors.subject
        })
      }, /*#__PURE__*/_react["default"].createElement("label", {
        className: "control-label"
      }, "Subject*"), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("input", {
        type: "text",
        className: "form-control",
        value: subject,
        onChange: function onChange(e) {
          _this2.setState({
            subject: e.target.value
          });
        }
      }), errors.subject && /*#__PURE__*/_react["default"].createElement("p", {
        className: (0, _classnames["default"])('help-block', _modalstyle_saveMessageScheduleMessage["default"].inputError)
      }, errors.subject)))), (method === 'email' || method === 'sms') && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('form-group', _modalstyle_saveMessageScheduleMessage["default"].textField, {
          'has-error': errors.body
        })
      }, /*#__PURE__*/_react["default"].createElement("label", {
        className: "control-label"
      }, "Body", method === 'email' && /*#__PURE__*/_react["default"].createElement("span", null, "\xA0(upper)\xA0", this.renderHtmlTagTooltip())), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("textarea", {
        className: "form-control",
        value: body,
        onChange: function onChange(e) {
          _this2.setState({
            body: e.target.value
          });
        }
      }), errors.body && /*#__PURE__*/_react["default"].createElement("p", {
        className: (0, _classnames["default"])('help-block', _modalstyle_saveMessageScheduleMessage["default"].inputError)
      }, errors.body)))), method === 'email' && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('form-group', _modalstyle_saveMessageScheduleMessage["default"].textField, {
          'has-error': errors.actionText
        })
      }, /*#__PURE__*/_react["default"].createElement("label", {
        className: "control-label"
      }, "Button Text"), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("input", {
        type: "text",
        className: "form-control",
        value: actionText,
        onChange: function onChange(e) {
          _this2.setState({
            actionText: e.target.value
          });
        }
      }), errors.actionText && /*#__PURE__*/_react["default"].createElement("p", {
        className: (0, _classnames["default"])('help-block', _modalstyle_saveMessageScheduleMessage["default"].inputError)
      }, errors.actionText))), /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('form-group', _modalstyle_saveMessageScheduleMessage["default"].textField, {
          'has-error': errors.actionUrl
        })
      }, /*#__PURE__*/_react["default"].createElement("label", {
        className: "control-label"
      }, "Button URL"), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("input", {
        type: "text",
        className: "form-control",
        value: actionUrl,
        onChange: function onChange(e) {
          _this2.setState({
            actionUrl: e.target.value
          });
        }
      }), errors.actionUrl && /*#__PURE__*/_react["default"].createElement("p", {
        className: (0, _classnames["default"])('help-block', _modalstyle_saveMessageScheduleMessage["default"].inputError)
      }, errors.actionUrl))), /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('form-group', _modalstyle_saveMessageScheduleMessage["default"].textField, {
          'has-error': errors.outroLines
        })
      }, /*#__PURE__*/_react["default"].createElement("label", {
        className: "control-label"
      }, "Body (lower)\xA0", this.renderHtmlTagTooltip()), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("textarea", {
        className: "form-control",
        value: outroLines,
        onChange: function onChange(e) {
          _this2.setState({
            outroLines: e.target.value
          });
        }
      }), errors.outroLines && /*#__PURE__*/_react["default"].createElement("p", {
        className: (0, _classnames["default"])('help-block', _modalstyle_saveMessageScheduleMessage["default"].inputError)
      }, errors.outroLines)))), !this.props.hideMessageReplacementNotes && /*#__PURE__*/_react["default"].createElement("div", {
        className: _modalstyle_saveMessageScheduleMessage["default"].subNote
      }, "Note: To place the Data Collection Wave link in the message, type", ' ', /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].bold
      }, "%URL%"), " and the link will automatically be filled in when the message is sent. You can also insert", ' ', /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].bold
      }, "%firstName%"), ",", ' ', /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].bold
      }, "%lastName%"), ", or", ' ', /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].bold
      }, "%fullName%"), ".", ' ', ['on_respondent_complete_notify', 'on_respondent_complete_module_notify', 'on_respondent_complete_survey_notify'].includes(condition) && /*#__PURE__*/_react["default"].createElement("span", null, "These replacement variables refer to information about the", ' ', /*#__PURE__*/_react["default"].createElement("i", null, "Respondent"), ", not the ", /*#__PURE__*/_react["default"].createElement("i", null, "Recipient"), ".")), !!Fortress.user.acting.is_super_user && !this.props.hideMessageReplacementNotes && /*#__PURE__*/_react["default"].createElement("div", {
        className: _modalstyle_saveMessageScheduleMessage["default"].subNote
      }, "To specify the URL of a different deployment, you can use one of the following two forms:", ' ', /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].bold
      }, "%dcwURLByHandle:your_custom_handle_here%"), ' ', "or", ' ', /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].bold
      }, "%dcwURLByEndpoint:your_custom_endpoint_here%"), ". You can specify data starting at the recipient pawn by using a \":\" separated path (e.g.,", ' ', /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].bold
      }, "%pawn:data:customPawnField%"), ").")))), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        trigger: /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          className: "btn btn-default"
        }, "Preview"),
        title: /*#__PURE__*/_react["default"].createElement("span", {
          className: _modalstyle_saveMessageScheduleMessage["default"].title
        }, "Previewing message"),
        size: method.toUpperCase() === 'EMAIL' ? 'large' : 'small'
      }, /*#__PURE__*/_react["default"].createElement(_MessageViewer["default"], {
        messageObject: previewMessageObject
      })), /*#__PURE__*/_react["default"].createElement("button", {
        className: (0, _classnames["default"])('btn btn-primary', _style["default"].submitButton, recipientsType === '' && 'disabled'),
        type: "button",
        disabled: isSubmitting || recipientsType === '' || hasErrors,
        onClick: function onClick() {
          _this2.setState({
            isSubmitting: true
          });
          _this2.updateAllEditingRecipients();
          if (isAddingRecipient) {
            _this2.addRecipient();
          }
          isEditing ? _this2.onEditSubmit() : _this2.onSaveSubmit();
        }
      }, isSubmitting ? 'Submitting...' : submitVar))));
    }
  }]);
  return SaveMessageModalContents;
}(_react["default"].Component);
_defineProperty(SaveMessageModalContents, "propTypes", {
  assignments: _propTypes["default"].array,
  closeModal: _propTypes["default"].func,
  deploymentId: _propTypes["default"].number.isRequired,
  deployments: _propTypes["default"].array,
  messageList: _propTypes["default"].array,
  hideMessageReplacementNotes: _propTypes["default"].bool,
  isEditing: _propTypes["default"].bool,
  messageObj: _propTypes["default"].object,
  requeryCallback: _propTypes["default"].func
});
_defineProperty(SaveMessageModalContents, "defaultProps", {
  messageObj: null
});
var mapStateToProps = function mapStateToProps(state) {
  return {
    assignments: (0, _admin.getCurrentProjectAssignments)(state.assignment.admin),
    deployments: (0, _admin.getCurrentProjectDeployments)(state.assignment.admin)
  };
};
var _default = (0, _reactRedux.connect)(mapStateToProps)(SaveMessageModalContents);
exports["default"] = _default;